import { noNullFields, SupabaseServiceView } from "../../../server/supabase/base-supabase-service";
import type { Tags } from "../../merge-tag/types";

export class SupabaseMergeTagService extends SupabaseServiceView<"merge_tags"> {
  table = "merge_tags" as const;

  async getAllMergeTags(): Promise<Tags> {
    const [{ data: v2tagData }, { data: v1tagData }] = await Promise.all([
      new SupabaseMergeTagServiceV2(this.client).getAll(null, {
        order: [{ column: "id" }],
      }),
      super.getAll(null, {
        order: [{ column: "id" }],
      }),
    ]);

    const v2Tags = v2tagData?.map((tag) => ({
      ...tag,
      version: 2 as const,
    }));
    const v1Tags = v1tagData?.map((tag) => ({
      ...tag,
      name: tag.id?.endsWith("_library") ? `${tag.name!} (Library)` : tag.name,
      version: 1 as const,
    }));

    return [
      ...(noNullFields(v1Tags) && v1Tags ? v1Tags : []),
      ...(noNullFields(v2Tags) && v2Tags ? v2Tags : []),
    ];
  }
}

class SupabaseMergeTagServiceV2 extends SupabaseServiceView<"merge_tags_2024_08_14"> {
  table = "merge_tags_2024_08_14" as const;
}
